import { apiUrl } from '../config/api';

// FAT-33: o log de atividade vai para o backend próprio. O token só segue no Authorization
// (validado no backend), nunca no corpo; usuário e IP vêm do backend. Sem login, nada é enviado.
// Falha de rede ou 5xx é engolida (sem retry) para não bloquear a navegação.
export const createUserLog = async (dadosLog) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;

    const logPayload = {
      componente: dadosLog.componente,
      acao: dadosLog.acao,
      caminho: dadosLog.caminho || window.location.pathname,
      navegador: dadosLog.navegador || navigator.userAgent,
      id_sessao: dadosLog.id_sessao || localStorage.getItem('idSessao'),
      detalhes: dadosLog.detalhes || ''
    };

    const response = await fetch(apiUrl('/log/addLog'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(logPayload)
    });

    if (!response.ok) throw new Error('Falha ao criar log');
    return await response.json();
  } catch (error) {
    console.error('Erro ao criar log:', error);
    return null;
  }
};

export const buscarLogsUsuario = async (idUsuario) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return [];
    const response = await fetch(apiUrl(`/log/userlogs/${encodeURIComponent(idUsuario)}`), {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) throw new Error('Falha ao buscar logs');
    return await response.json();
  } catch (error) {
    console.error('Erro ao buscar logs:', error);
    return [];
  }
};
